import React, { Component } from "react";
import { Form } from "react-form";
import { connect } from "react-redux";
import { map, pickBy } from "lodash";
import moment from "moment";
import TextFields from "../UI/TextFiled";
import DatePickerUI from "../UI/DatePicker";
import {
  getManagmanetData,
  getCurrentManagmanetData
} from "../../store/actions/managmantDashboardData";
import OrderSummary from "./OrderSummray";
import DriverPerformance from "./DriverPerformance";
import OperationTeamPerformance from "./OperationTeamPerformance";
import UserPerformance from "./UserPerformance";
import OrderPerformance from "./OrderPerformance";
import FinancialPerformance from "./FinancialPerformance";
const Json2csvParser = require("json2csv").Parser;

class ManagementDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedComponent: [
        { id: 1, value: false },
        { id: 2, value: false },
        { id: 3, value: false },
        { id: 4, value: false },
        { id: 5, value: false },
        { id: 6, value: false }
      ],
      allChecks: false,
      checks: [],
      name: "",
      dateFrom: null,
      dateTo: null
    };
    this.handleAllChecks = this.handleAllChecks.bind(this);
    this.handleChecks = this.handleChecks.bind(this);
    this.handleComponent = this.handleComponent.bind(this);
    this.dateFrom = this.dateFrom.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    this.props.getManagmanetData();
  }
  async handleComponent(id, check) {
    let myData = await [...this.state.checkedComponent];

    myData.map(data => {
      if (id === data.id) {
        return (data.value = !!this.state.checks.length);
      }
      return myData;
    });
    console.log("dataid", myData, id);
    this.setState({
      checkedComponent: myData
    });
  }
  async handleAllChecks(value, id, check) {
    this.setState({
      allChecks: !this.state.allChecks
    });
    if (!this.state.allChecks) {
      const allChecks = map(this.props.managmantData[value], data => {
        return {
          id: data.id,
          value: data.title
        };
      });

      await this.setState({ checks: allChecks });
    } else {
      await this.setState({ checks: [] });
    }
    let numId = Number(id);

    this.handleComponent(numId, check);
  }

  handleChecks(value, id, check, componentId, dataValue) {
    const checksData = this.state.checks;
    const arr = [];
    console.log("olala", value);
    // this.state.checks.length < 1 && arr.push(value);
    // this.setState({
    //   ...this.state,
    //   checks: arr,
    //   name: dataValue.replace("_", "-").toLowerCase()
    // });

    if (componentId) {
      this.handleComponent(componentId, check);
    }
    if (check === true) {
      checksData.push(value);
      this.setState({
        ...this.state,
        checks: checksData
      });
    }

    if (check === false) {
      checksData.splice(checksData.indexOf(value));
      this.setState({
        ...this.state,
        checks: checksData
      });
    }
    console.log("checksdata", checksData);
    if (
      this.props.managmantData[dataValue].length === this.state.checks.length
    ) {
      this.setState({ allChecks: !this.state.allChecks });
    }
  }

  dateFrom(lag, date) {
    if (lag === "From") {
      this.setState({ dateFrom: moment(date).format("YYYY-MM-DD") });
    } else if (lag === "To") {
      this.setState({ dateTo: moment(date).format("YYYY-MM-DD") });
    }
  }
  //   (saveData= ()=> {
  //     var a = document.createElement("a");
  //     document.body.appendChild(a);
  //     a.style = "display: none";
  //     return function (data, fileName) {
  //         var json = JSON.stringify(data),
  //             blob = new Blob([json], {type: "octet/stream"}),
  //             url = window.URL.createObjectURL(blob);
  //         a.href = url;
  //         a.download = fileName;
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //     };
  // }());
  async handleClick() {
    let exportData = {
      startDate: this.state.dateFrom,
      endDate: this.state.dateTo,
      data: this.state.checks
    };
    if (exportData.data.length < 1) {
      console.log("empty data");
    } else {
      const req_data = await this.props.getCurrentManagmanetData(
        this.props.auth.token,
        this.state.name,
        this.state.dateFrom,
        this.state.dateTo
      );

      const mydata = { ...req_data.payload.results };

      const filtered = Object.keys(mydata)
        .filter(key => this.state.checks.includes(key))
        .reduce((obj, key) => {
          obj[key] = mydata[key];
          return obj;
        }, {});

      // const ddd = [("aaa": "vvvv"), ("bbb": "vvcds")];
      const rows = [
        Object.keys(filtered),
        Object.values(filtered, data => {
          if (data instanceof Array) {
            const index = filtered.indexOf(data);
            return (filtered[index] = data.join(","));
          }
        })
      ];
      let csvContent = "data:text/csv;charset=utf-8,";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += rowArray + "\r\n";
      });
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "my_data.csv");

      link.click();

      //   const url = window.URL.createObjectURL(
      //     new Blob([JSON.stringify(filtered)], {
      //       type: "text/csv"
      //     })
      //   );
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.setAttribute("download", "Dashboard.csv");
      //   link.click();
    }
  }
  render() {
    const { managmantData } = this.props;

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Management Dashboard</h1>
              </div>
              <div className="col-xs-3" />
            </div>
          </div>
        </div>
        <div className="container inner-padding box">
          <div className="box-body">
            <div className="row align-center">
              <div className="col-xs-8">
                <Form onSubmit={this.submitted}>
                  {formApi => (
                    <form onSubmit={formApi.submitForm}>
                      <div className="row">
                        <div className="col-xs-4">
                          <DatePickerUI
                            label="From"
                            hintText="From"
                            dateFrom={this.dateFrom}
                          />
                        </div>
                        <div className="col-xs-4 ml-30">
                          <DatePickerUI
                            label="To"
                            hintText="To"
                            dateFrom={this.dateFrom}
                          />
                        </div>
                      </div>
                    </form>
                  )}
                </Form>
              </div>
              <div className="col-xs-4 text-right">
                <button
                  className="btn filled primary min-180"
                  onClick={this.handleClick}
                >
                  Export
                </button>
              </div>
            </div>
            <Form onSubmit={this.submitted} pure={false}>
              {formApi => (
                <form onSubmit={formApi.submitForm}>
                  <div className="row mt-35">
                    <OrderSummary
                      data={managmantData.Order_Summary}
                      name={"Order Summary"}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                    <DriverPerformance
                      data={managmantData.Driver_Performance}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                    <OperationTeamPerformance
                      data={managmantData.Operation_Team_Performance}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                  </div>
                  <div className="row mt-35">
                    <UserPerformance
                      data={managmantData.User_Performance}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                    <OrderPerformance
                      data={managmantData.Order_Performance}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                    <FinancialPerformance
                      data={managmantData.Financial_Performance}
                      handleChecks={this.handleChecks}
                      handleAllChecks={this.handleAllChecks}
                      allChecked={this.state.allChecks}
                      checkComponent={this.state.checkedComponent}
                    />
                  </div>
                </form>
              )}
            </Form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    managmantData: state.managmantData,
    auth: state.auth
  };
}

export default connect(
  mapStateToProps,
  { getManagmanetData, getCurrentManagmanetData }
)(ManagementDashboard);



// WEBPACK FOOTER //
// ./src/components/Management-dashboard/Management-dashboard.js